export interface CustomContent {
  id: string;
  contentType: string; // 'CUSTOM'
  name: string;
  url: string;
  content: string;
  iconType: IconType;
}

export enum IconType {
  POST = 'POST',
  VIDEO = 'VIDEO',
  TROPHY = 'TROPHY',
  TICKET = 'TICKET',
  MESSAGE = 'MESSAGE',
  MUSIC = 'MUSIC',
  FILM = 'FILM',
  STAR = 'STAR',
  PAGE = 'PAGE',
}
